/**
 * Detects the user's platform (web, iOS app, or Android app) based on the provided user agent string.
 *
 * @param userAgent - The user agent string to analyze.
 * @returns 'ios app' if the user is on an iOS WebView, 'android app' if on an Android WebView, or 'web' otherwise.
 *
 * This function is useful for distinguishing between users accessing the site via a browser or an in-app WebView.
 */
export function getPlatformFromUserAgent(userAgent: string) {
  if (!userAgent) {
    return "web";
  }

  const ua = userAgent.toLowerCase();

  // iOS WebView detection
  const isIOS = /iphone|ipad|ipod/.test(ua);
  const isAppleWebKit = /applewebkit/.test(ua);
  const isSafari = /safari/.test(ua);
  const isCriOS = /crios/.test(ua); // Chrome on iOS
  const isFxiOS = /fxios/.test(ua); // Firefox on iOS

  const isiOSWebView =
    isIOS && isAppleWebKit && !isSafari && !isCriOS && !isFxiOS;

  if (isiOSWebView) {
    return "ios app";
  }

  // Android WebView detection (includes 'wv' or version with "Version/X.X")
  const isAndroid = /android/.test(ua);
  const isAndroidWebView = /wv/.test(ua) || /version\/[\d.]+/.test(ua);

  if (isAndroid && isAndroidWebView) {
    return "android app";
  }

  return "web";
}
